import Box from "@mui/material/Box";

import { primaryLight } from "../../../constants/colors";
import ImageContainer from "../ImageContainer";

interface Props {
  isSelected: boolean;
  file: any;
  onClick: any;
}

const MediaItem: React.FC<Props> = ({ isSelected, file, onClick }) => {
  const itemWidth: number = 100 / 8;

  return (
    <Box
      sx={{
        border: 4,
        borderColor: (theme) =>
          isSelected ? primaryLight(theme) : "transparent",
        width: `${itemWidth}%`,
        float: "left",
        cursor: "pointer",
      }}
      onClick={onClick}
    >
      <Box sx={{ maxWidth: "100%" }}>
        <ImageContainer
          src={file.fileUrl}
          thumb={file.fileUrl}
          alt={file.filename}
        />
      </Box>
    </Box>
  );
};

export default MediaItem;
